import { LocalStorageDataCache, gDataCache } from "./dataCache.js";
import { buildLiveSnapshot } from "./liveWatchability.js";


// function getProxiedRequestPromise(urlString)
// {
//     let promise = fetch(proxiedUrl, {headers: proxyRequestHeaders}).then(response => {
//             if (!response.ok) { // Check for fetch errors
//                 throw new Error(`Error fetching ${[proxiedUrl]}: ${response.status}`);
//             }
//             return response.json();
//         });

//     return promise;
// }

export function getProxiedEspnRequestPromise(urlString) {

    // ESPN sends 'Access-Control-Allow-Origin: *' so we call it directly rather than via the
    // Cloudflare proxy (ESPN started returning 403s to Cloudflare Worker IPs in Oct 2026).
    // Don't add custom request headers here -- they trigger a CORS preflight, which ESPN rejects with a 403.
    let proxiedUrl = urlString;

    // let cachedResult = gDataCache.get(urlString);
    // if (cachedResult !== null) {
    //     console.log("Reading cached game data for: " + urlString);
    //     return Promise.resolve(cachedResult);
    // }

    let promise = fetch(proxiedUrl).then(response => {
        if (!response.ok) { // Check for fetch errors
            throw new Error(`Error fetching ${[proxiedUrl]}: ${response.status}`);
        }

        // let jsonPromise = response.json().then(jsonResult => {
        //     let complete = false;
        //     let inProgress = false;
        //     let startTime = null;
        //     let timeNow = Date.now();
        //     if (jsonResult && jsonResult.header && jsonResult.header.competitions && jsonResult.header.competitions.length > 0) {
        //         complete = jsonResult.header.competitions[0].status.completed;
        //         startTime = Date.parse(jsonResult.header.competitions[0].date);
        //         inProgress = !complete && startTime < timeNow;
        //     }
        //     gDataCache.set(urlString, jsonResult,
        //         complete ?
        //             (timeNow + 1000000 * 60 * 60 * 1000) : // 100000 hours for completed games
        //             inProgress ? (timeNow + 5 * 60 * 1000) : // 5 minutes for in-progress games
        //                 startTime
        //     );
        //     return Promise.resolve(jsonResult); //response.json();
        // });

        return response.json()
    });
    return promise;
}
function extractWeekEventIds(data) {
  const weekEvents = {};
  if (!data.events) return weekEvents;
  data.events.forEach(event => {
    const weekNum = event.week && event.week.number;
    const eventId = event.id;
    if (weekNum && eventId) {
      if (!weekEvents[weekNum]) weekEvents[weekNum] = [];
      weekEvents[weekNum].push(
        {
            eventId: eventId,
            startDate: event.date,
            name: event.name
        });
    }
  });
  return weekEvents;
}


// export function doEspnStuff()
// {
//     let promises = [];

//     promises.push(getProxiedEspnRequestPromise('https://site.api.espn.com/apis/site/v2/sports/football/college-football/scoreboard'));

//     Promise.all(promises)
//         .then(results => {
//             let schedule = results[0];
//             let weekEvents = extractWeekEventIds(schedule);

//             // console.log(JSON.stringify(weekEvents));
//         })
//         .catch(error => {
//             console.error("Error fetching data:", error);
//         });

//     // let scoringDrivesPromise = getScoringDrivesEspn("401628406");
//     // scoringDrivesPromise.then(scoringDrives => {
//     //     console.log("Scoring Drives:", JSON.stringify(scoringDrives));
//     }).catch(error => {
//         console.error("Error fetching scoring drives:", error);
//     });
// }


function getElapsedGameTime(timeString, quarter) {
    if (!timeString || !quarter) {
        console.error("Invalid timeString or quarter:", timeString, quarter);
        return null;
    }
    let parts = timeString.split(':');
    if (parts.length !== 2) {
        console.error("Invalid time format:", timeString);
        return null;
    }
    let minutes = parseInt(parts[0], 10);
    let seconds = parseInt(parts[1], 10);
    if (isNaN(minutes) || isNaN(seconds)) {
        console.error("Invalid time format:", timeString);
        return null;
    }
    
    if (quarter < 1) {
        console.error("Invalid quarter number:", quarter);
        return null;
    }
    let isOvertime = (quarter > 4);
    
    // Calculate elapsed time in seconds
    // Each quarter is 15 minutes, so we calculate the total seconds elapsed
    // from the start of the game to the given time in the specified quarter.
    // The formula is: (quarter - 1) * 15 * 60 + (15 - minutes - 1) * 60 + (60 - seconds)
    // where
    // - (quarter - 1) * 15 * 60 gives the total seconds for the completed quarters,
    // - (15 - minutes - 1) * 60 gives the seconds remaining in the current quarter,
    // - (60 - seconds) gives the remaining seconds
    // in the current minute.
    if (minutes < 0 || minutes > 15 || seconds < 0 || seconds > 60) {
        console.error("Invalid time values:", minutes, seconds);
        return null;
    }


    let secondsRemaining = minutes * 60 + seconds;
    let elapsedSecondsInQuarter = 15 * 60 - secondsRemaining;
    let quarterSecondsElapsed = isOvertime ? 
        60 * 60 + (quarter - 4) * 60 : // Add one additional minute for each overtime quarter
        (quarter - 1) * 15 * 60;
    return quarterSecondsElapsed + elapsedSecondsInQuarter;

    // Calculate total elapsed time in seconds  
    // return (quarter - 1) * 15 * 60 + (15 - minutes - 1) * 60 + (60 - seconds);
}

const kScoringDriveCacheVersion = 4;
export function getScoringDrivesEspn(gameId) {
    let url = `https://site.api.espn.com/apis/site/v2/sports/football/college-football/summary?event=${gameId}`;

    let cachedResult = gDataCache.get(url, kScoringDriveCacheVersion);
    if (cachedResult) {
        console.log("Reading cached scoring drive data for: " + url);
        return Promise.resolve(cachedResult);
    }

    let promise = getProxiedEspnRequestPromise(url);



    let scoringDrivesPromise = promise
    .then(data => {



        const drives = data.drives && data.drives.previous ? data.drives.previous : [];
        let scoringDrives = [];
        let lastWinProbability = null;
        for (let i = 0; i < drives.length; i++) {
            const drive = drives[i];
            if (!drive.isScore) {
                continue; // Skip drives that are not scoring drives
            }
            // Try to get team id from team object, fallback to abbreviation if needed
            const teamId = drive.team && drive.team.abbreviation ? drive.team.abbreviation : null;

            // Find scoringType.abbreviation from plays if isScore is true
            let homeScore = -1;
            let awayScore = -1;
            

            // @TODO -- need to add other types of plays that are exciting -- interceptions, fumbles, missed field goals, going for it on 4th down, etc.

            let scoringPlay = null;

            
            if (drive.isScore && Array.isArray(drive.plays)) {

                // Iterate through plays in reverse order to find the scoring play (which is usually the last one)
                for (let i = 0; i < drive.plays.length; i++) {
                    const play = drive.plays[i];
                    if (play.scoringPlay) {
                        scoringPlay = play;

                        // Very occassionally, a drive can have multiple scoring plays (i.e., defensive score on PAT) so we need to gather all of them vs. bailing on the first one we find.
                        homeScore = scoringPlay.homeScore;
                        awayScore = scoringPlay.awayScore;

                        let prob = data.winprobability && data.winprobability.find(wp => (wp.playId == scoringPlay.id)); //.localeCompare(scoringPlay.id) == 0));
                        if (prob == null) {
                            prob = lastWinProbability;
                            if (prob == null) {
                                console.warn("No win probability found for scoring play: " + scoringPlay.id + ", using last known win probability");
                                for (let j = 0; j < data.winprobability.length; j++) {
                                    if (data.winprobability[j].playId < scoringPlay.id) {
                                        prob = data.winprobability[j];
                                    } 
                                    else {
                                        break; // win probabilities are sorted by playId, so we can stop searching once we find one that is greater than or equal to the scoring play id
                                    }
                                }
                            }   
                        }
                        else 
                        {
                            lastWinProbability = prob;
                        }


                        console.assert(prob, "Win probability should not be null for scoring play: " + scoringPlay.id);
                        console.assert(homeScore >= 0 && awayScore >= 0, "Home and Away scores should be valid numbers");

                        let clockValue = play.clock?.displayValue ||"0:00";

                        let quarter = play.period.number; //drive.end?.period?.number || drive.start?.period?.number;
                        let scoringInfo = {
                            homeScore,
                            awayScore,
                            endQuarter: quarter,
                            endTime: clockValue,
                            homeWinPercentage: prob ? prob.homeWinPercentage : -1.0,

                            // @TODO -- End time can be 0:00 if no drive.end.clock
                            endTimeMinutes: getElapsedGameTime(clockValue, quarter) / 60,
                        };
                        scoringDrives.push(scoringInfo);
                    }
                }
            }

            if (scoringPlay === null) {
                continue; // No scoring play found, skip this drive
            }



        };

        // console.log("Scoring Drives for game " + gameId + ":");
        // console.log(data.leaders[0].team.displayName + " vs. " + data.leaders[1].team.displayName);
        // console.log(JSON.stringify(scoringDrives, null, 2));

        let complete = false;
        // let inProgress = false;
        // let startTime = null;
        let timeNow = Date.now();
        if (data && data.header && data.header.competitions && data.header.competitions.length > 0) {
            complete = data.header.competitions[0].status.type.completed;
            // startTime = Date.parse(data.header.competitions[0].date);
            // inProgress = !complete && startTime < timeNow;
        }

        gDataCache.set(url, JSON.stringify(scoringDrives), 
            new Date(
                complete ? 
                (timeNow + 1000000 * 60 * 60 * 1000) : // 100000 hours for completed games
                (timeNow + 5 * 60 * 1000)), // 5 minutes for in-progress games
            kScoringDriveCacheVersion); 

        return scoringDrives;
    })
    .catch(error => {
        console.error("Error fetching game drives:", error);
    });

    return scoringDrivesPromise;
}


const kMatchupPredictorVersion = 2;
const kMatchupPredictorPrefix = "pregame > ";
export function getMatchupPredictionEspn(gameId) {
    let url = `https://site.api.espn.com/apis/site/v2/sports/football/college-football/summary?event=${gameId}`;

    let cachedResult = gDataCache.get(kMatchupPredictorPrefix + url, kMatchupPredictorVersion);
    if (cachedResult) {
        // console.log("Reading cached matchup prediction data for: " + url);
        return Promise.resolve(cachedResult);
    }

    let promise = getProxiedEspnRequestPromise(url);



    let matchupPredictorPromise = promise
    .then(data => {
        let predictor = data.predictor;
        if (predictor == null) {
            console.warn("No matchup predictor data found for game: " + gameId);
            return [];
        }

        let homeTeamWin = predictor.homeTeam.gameProjection;
        let awayTeamWin = predictor.awayTeam.gameProjection;
        let delta = Math.abs(homeTeamWin - awayTeamWin);

        let matchupResult = {};
        matchupResult.homeTeamWin = homeTeamWin;
        matchupResult.awayTeamWin = awayTeamWin;
        matchupResult.delta = delta;

        // console.log("Scoring Drives for game " + gameId + ":");
        // console.log(data.leaders[0].team.displayName + " vs. " + data.leaders[1].team.displayName);
        // console.log(JSON.stringify(scoringDrives, null, 2));

        let complete = false;
        // let inProgress = false;
        // let startTime = null;
        let timeNow = Date.now();
        // if (data && data.header && data.header.competitions && data.header.competitions.length > 0) {
        //     complete = data.header.competitions[0].status.type.completed;
        //     // startTime = Date.parse(data.header.competitions[0].date);
        //     // inProgress = !complete && startTime < timeNow;
        // }

        // by default, cache for an hour
        let expiryTime = timeNow + 60 * 60 * 1000;
        if (data && data.header && data.header.competitions && data.header.competitions.length > 0) {
            let startDateMs = Date.parse(data.header.competitions[0].date); // this returns the start date in milliseconds
            // startDateMs = startDateMs.getMilliseconds();

            // if game is more than 24 hours away, expiry time should be set to 24 hours before the start time
            if (startDateMs - timeNow > 24 * 60 * 60 * 1000) {
                expiryTime = startDateMs - 24 * 60 * 60 * 1000;
            }

        }


        let stringifiedResult = JSON.stringify(matchupResult);
        gDataCache.set(
            kMatchupPredictorPrefix + url, 
            stringifiedResult, 
            new Date(expiryTime),
            kMatchupPredictorVersion); 

        return matchupResult;
    })
    .catch(error => {
        console.error("Error fetching game drives:", error);
    });

    return matchupPredictorPromise;
}

// Returns the pre-game matchup prediction if it's already in the cache (no network request), otherwise null.
export function getCachedMatchupPredictionEspn(gameId) {
    let url = `https://site.api.espn.com/apis/site/v2/sports/football/college-football/summary?event=${gameId}`;
    return gDataCache.get(kMatchupPredictorPrefix + url, kMatchupPredictorVersion);
}


const kLiveSnapshotVersion = 4; // bump when the snapshot shape changes
const kLiveSnapshotPrefix = "live > ";
const kLiveSnapshotCacheMinutes = 2; // short, so a page reload shows a fresh rating
// Resolves to a live-game snapshot (see liveWatchability.js), or null if ESPN doesn't have enough data to rate it.
export function getLiveSnapshotEspn(gameId) {
    let url = `https://site.api.espn.com/apis/site/v2/sports/football/college-football/summary?event=${gameId}`;

    let cachedResult = gDataCache.get(kLiveSnapshotPrefix + url, kLiveSnapshotVersion);
    if (cachedResult) {
        return Promise.resolve(cachedResult);
    }

    return getProxiedEspnRequestPromise(url)
        .then(data => {
            let snapshot = buildLiveSnapshot(data);
            if (snapshot != null) {
                gDataCache.set(
                    kLiveSnapshotPrefix + url,
                    JSON.stringify(snapshot),
                    new Date(Date.now() + kLiveSnapshotCacheMinutes * 60 * 1000),
                    kLiveSnapshotVersion);
            }
            return snapshot;
        })
        .catch(error => {
            console.error("Error fetching live game data:", error);
            return null;
        });
}
